import { styled, AccordionDetails } from '@mui/material';

export const StyledAccordionDetails = styled(AccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  paddingTop: 0,
  margin: 0
})); 
